import BankTransferTileSvg from '@assets/images/svg/bank-transfer-tile.svg';
import React from 'react';
import { View } from 'react-native';

export interface BankTransferTileIconProps {
    /** Rendered width — height scales to match the SVG's native 36:40 aspect ratio. */
    size?: number;
    color?: string;
}

/** Self-contained tile (white rounded box + glyph baked in) for the "Bank Transfer" payment method row. */
export function BankTransferTileIcon({ size = 36, color = '#1A1A1A' }: Readonly<BankTransferTileIconProps>) {
    const height = (size / 36) * 40;
    return (
        <View style={{ width: size, height, justifyContent: 'center', alignItems: 'center' }}>
            <BankTransferTileSvg width={size} height={height} color={color} />
        </View>
    );
}

export default BankTransferTileIcon;
